import {ConfigKey} from '@nursio-link/common';
import {forwardRef, type ReactNode} from 'react';

import logotype from '@/assets/nursio-logotype.svg';
import signet from '@/assets/nursio-signet.svg';
import {graphqlClient} from '@/services/graphqlClient';
import {useGetConfigByKeyQuery} from '@/services/graphqlHooks';
import {cn} from '@/utils/ui';

export type PrintLayoutProps = {
  children: ReactNode;
  className?: string;
};

export const PrintLayout = forwardRef<HTMLDivElement, PrintLayoutProps>(
  ({children, className}, ref) => {
    const {data: careFacilityLogoData} = useGetConfigByKeyQuery(graphqlClient, {
      key: ConfigKey.CARE_FACILITY_LOGO,
    });

    const careFacilityLogoFileName =
      careFacilityLogoData?.getConfigByKey.value.stringValue;
    const careFacilityLogoUrl = careFacilityLogoFileName
      ? `https://${window.DOMAIN_NAME}/${careFacilityLogoFileName}`
      : undefined;

    return (
      <div
        ref={ref}
        className={cn(
          'print-root text-xs leading-snug print:w-[180mm] print:max-w-none print:border-0 print:p-0',
          className
        )}
      >
        <div className="flex flex-row items-center justify-between gap-3 py-3">
          <div className="flex grow flex-row items-center justify-start gap-2">
            <img
              src={signet}
              alt="Nursiolink"
              className="max-h-8 object-contain"
            />
            <img
              src={logotype}
              alt="Nursiolink"
              className="max-h-6 object-contain"
            />
          </div>
          {careFacilityLogoUrl && (
            <img
              src={careFacilityLogoUrl}
              alt="Care facility logo"
              className="max-h-8 w-auto object-contain"
            />
          )}
        </div>
        {children}
      </div>
    );
  }
);

PrintLayout.displayName = 'PrintLayout';
